// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse {
    static getAttributeTypeMap() {
        return DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse.attributeTypeMap;
    }
}
DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse.discriminator = undefined;
DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse.additionalProperties = false;
DocumentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=documentsV2FillablePdfGenerateFieldsFromFileGenerateFieldsFromFileResponse.js.map